import { useHydrating } from "eddev/routing"
import { useEffect, useState } from "react"

export function useIsMobile(maxSize = 600) {
  return useMatchQuery(`(max-width: ${maxSize}px)`)
}

/**
 * Returns true or false, whether the media query matches or not.
 * @param query eg. "(max-width: 768px)"
 * @returns boolean
 */
export function useMatchQuery(query: string): boolean {
  const hydrating = useHydrating()

  const [matches, setMatches] = useState(() => {
    if (hydrating) return false
    const mediaQuery = getMedia(query)
    return mediaQuery.matches
  })

  useEffect(() => {
    const media = getMedia(query)
    setMatches(media.matches)
    const handleChange = (e: MediaQueryListEvent) => {
      setMatches(e.matches)
    }
    media.addEventListener("change", handleChange)
    return () => {
      media.removeEventListener("change", handleChange)
    }
  }, [query])

  return matches
}

function getMedia(query: string) {
  const mediaQuery = window.matchMedia("(max-width: 768px)")
  return mediaQuery
}
